import React from 'react';

export interface ArrowRightShortProps {
  className?: string;
}

const ArrowRightShort: React.FC<ArrowRightShortProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73357 6.04089L5.66465 1.97197L7.12153 0.515087L13.6775 7.07107L7.12153 13.627L5.66465 12.1702L9.73357 8.10124L0.565551 8.10124L0.56555 6.04089L9.73357 6.04089Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowRightShort;
